import * as React from 'react';
import { Redirect, Route, Switch } from 'react-router';
import { Link } from 'react-router-dom';
import { Requests } from './Requests';
import { RequestAcceptPage } from './RequestAcceptPage/RequestAcceptPage';
import { RequestsArchive } from '../RequestsArchive/RequestsArchive';
import { getArchiveRequestsCount } from 'Src/helpers/service/admin/requestsArchive';
import './Requests.css';

interface RequestsShellState {
  newCount?: number;
  archiveCount?: number;
}

class RequestsShell extends React.Component<any, RequestsShellState> {
  constructor(props) {
    super(props);

    this.state = {};
  }

  setNeedUpdate = (): void => {
    if (typeof this.props.setNeedUpdate === 'function') {
      this.props.setNeedUpdate();
    }
  };

  componentDidMount(): void {
    this.refreshArchiveCount();
  }

  refreshArchiveCount = (): void => {
    getArchiveRequestsCount(this.props.user)
      .then(result => this.onArchiveTotalChange(result.count))
      .catch(() => undefined);
  };

  onNewTotalChange = (newCount: number): void => {
    if (this.state.newCount !== newCount) {
      this.setState({ newCount });
      this.refreshArchiveCount();
    }
  };

  onArchiveTotalChange = (archiveCount: number): void => {
    if (this.state.archiveCount !== archiveCount) {
      this.setState({ archiveCount });
    }
  };

  renderTabs(): React.ReactNode {
    const { location } = this.props;
    const { newCount, archiveCount } = this.state;
    const isArchive = location.pathname.indexOf('/requests/archive') === 0;

    return (
      <div className="requestsHub-tabs" role="tablist" aria-label="Role requests">
        <Link className={!isArchive ? 'requestsHub-tab requestsHub-tab--active' : 'requestsHub-tab'} to="/requests" role="tab" aria-selected={!isArchive}>
          <span>Inbox</span>
          {typeof newCount === 'number' ? <b>{newCount}</b> : null}
        </Link>
        <Link className={isArchive ? 'requestsHub-tab requestsHub-tab--active' : 'requestsHub-tab'} to="/requests/archive" role="tab" aria-selected={isArchive}>
          <span>Archive</span>
          {typeof archiveCount === 'number' ? <b>{archiveCount}</b> : null}
        </Link>
      </div>
    );
  }

  render(): React.ReactNode {
    const { user } = this.props;

    return (
      <div className="requestsHub">
        <header className="requestsHub-head">
          <h1>Role requests</h1>
          {this.renderTabs()}
        </header>
        <div className="requestsHub-content">
          <Switch>
            <Route
              exact
              path="/requests"
              render={props => <Requests {...props} user={user} setNeedUpdate={this.setNeedUpdate} onTotalChange={this.onNewTotalChange} />}
            />
            <Route
              exact
              path="/requests/archive"
              render={props => <RequestsArchive {...props} user={user} onTotalChange={this.onArchiveTotalChange} />}
            />
          </Switch>
        </div>
      </div>
    );
  }
}

export const RequestsArchiveRedirect = () => <Redirect to="/requests/archive" />;

export const RequestRouting = allProps => {
  return (
    <Switch>
      <Route
        exact
        path={'/requests/archive'}
        render={props => <RequestsShell {...props} user={allProps.user} setNeedUpdate={allProps.setNeedUpdate} />}
      />
      <Route
        exact
        path={'/requests'}
        render={props => <RequestsShell {...props} user={allProps.user} setNeedUpdate={allProps.setNeedUpdate} />}
      />
      <Route
        path={'/requests/:requestId'}
        render={props => <RequestAcceptPage {...props} user={allProps.user} setNeedUpdate={allProps.setNeedUpdate} />}
      />
    </Switch>
  );
};

RequestRouting.displayName = 'RequestRouting';
